"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CURRENCY_SYMBOL = exports.CURRENCY_SYMBOL_MAPPINGS = exports.CurrencySymbol = exports.AvailablePaymentCurrency = void 0;
var AvailablePaymentCurrency;
(function (AvailablePaymentCurrency) {
    AvailablePaymentCurrency["Cad"] = "cad";
    AvailablePaymentCurrency["Usd"] = "usd";
    AvailablePaymentCurrency["Gbp"] = "gbp";
    AvailablePaymentCurrency["Aud"] = "aud";
    AvailablePaymentCurrency["Nzd"] = "nzd";
    AvailablePaymentCurrency["Eur"] = "eur";
})(AvailablePaymentCurrency || (exports.AvailablePaymentCurrency = AvailablePaymentCurrency = {}));
var CurrencySymbol;
(function (CurrencySymbol) {
    CurrencySymbol["Dollar"] = "$";
    CurrencySymbol["Pound"] = "\u00A3";
    CurrencySymbol["Euro"] = "\u20AC";
})(CurrencySymbol || (exports.CurrencySymbol = CurrencySymbol = {}));
// Currency to Symbol mapping
exports.CURRENCY_SYMBOL_MAPPINGS = {
    [AvailablePaymentCurrency.Cad]: CurrencySymbol.Dollar,
    [AvailablePaymentCurrency.Usd]: CurrencySymbol.Dollar,
    [AvailablePaymentCurrency.Aud]: CurrencySymbol.Dollar,
    [AvailablePaymentCurrency.Nzd]: CurrencySymbol.Dollar,
    [AvailablePaymentCurrency.Gbp]: CurrencySymbol.Pound,
    [AvailablePaymentCurrency.Eur]: CurrencySymbol.Euro,
};
exports.DEFAULT_CURRENCY_SYMBOL = CurrencySymbol.Dollar;
